<template>
  <div>
    <!-- Navbar ของ Staff -->
    <StaffNavbar />
    <div>
      <header class="header">
        <h1>ตั้งค่าระบบ</h1>
      </header>
      <div class="container-fluid">
        <div class="py-1 px-5">
          <div class="bg-secondary-light mb-3">
            <!-- สถานะของระบบปัจจุบัน -->
            <div style="background-color: #964040" class="p-3">
              <span>
                <h4 class="text-white my-0">สถานะของระบบ</h4>
              </span>
            </div>
            <!-- แสดงสถานะปัจจุบัน -->
            <div class="status-container">
              <div
                :class="{
                  'status-open': isSystemOpen,
                  'status-closed': !isSystemOpen,
                }"
              >
                <strong>สถานะของระบบ:</strong>
                {{ isSystemOpen ? "เปิดใช้งาน" : "ปิดใช้งาน" }}
              </div>
            </div>
            <!-- แสดงวันเวลาที่ตั้ง Auto -->
            <div class="auto-status">
              <p>
                <strong>ระบบ Auto ตั้งค่าไว้:</strong> เปิดวันที่
                {{ formatDate(autoStartDate) }} ถึง
                {{ formatDate(autoEndDate) }}
                <br />
                ปีการศึกษา {{ studyYear }}
              </p>
            </div>

            <!-- ปุ่มเปิด/ปิด Manual -->
            <div style="background-color: #964040" class="p-3">
              <span>
                <h4 class="text-white my-0">การเปิด-ปิดระบบ (manual)</h4>
              </span>
            </div>
            <div class="manual-action-container">
              <button
                class="btn"
                :class="isSystemOpen ? 'btn-success' : 'btn-outline-success'"
                :disabled="isUpdatingSystemStatus || isSystemOpen"
                @click="updateSystemStatus('open')"
              >
                เปิดระบบทันที
              </button>
              <button
                class="btn"
                :class="!isSystemOpen ? 'btn-danger' : 'btn-outline-danger'"
                :disabled="isUpdatingSystemStatus || !isSystemOpen"
                @click="updateSystemStatus('close')"
              >
                ปิดระบบทันที
              </button>
            </div>

            <!-- ตั้งค่า Auto -->
            <div style="background-color: #964040" class="p-3">
              <span>
                <h4 class="text-white my-0">การเปิด-ปิดระบบ (auto)</h4>
              </span>
            </div>
            <div class="form-group ml-3">
              <div class="row mb-3">
                <!-- กล่องเลือกวันเปิดระบบ -->
                <div class="col-auto mb-2">
                  <label for="autoStartDate">เลือกวันเปิดระบบ:</label>
                  <input
                    type="date"
                    id="autoStartDate"
                    v-model="autoStartDate"
                    class="date-input"
                  />
                </div>

                <!-- กล่องเลือกวันปิดระบบ -->
                <div class="col-md-auto">
                  <label for="autoEndDate">เลือกวันปิดระบบ:</label>
                  <input
                    type="date"
                    id="autoEndDate"
                    v-model="autoEndDate"
                    class="date-input"
                  />
                </div>
                <!-- กล่องเลือกปีการศึกษา  -->
              </div>

              <div class="studyYear-box">
                <label for="studyYear">เลือกปีการศึกษา:</label>
                <div class="mb-3">
                  <input
                    type="number"
                    id="studyYear"
                    v-model="studyYear"
                    class="form-control"
                    :min="currentThaiYear - 1"
                    :max="currentThaiYear + 1"
                    @input="validateNumber('studyYear')"
                    @keydown="blockNegative"
                  />
                </div>
                <label for="studySemester">เลือกภาคเรียนการศึกษา:</label>

                <select
                  name="studySemester"
                  id="studySemester"
                  class="form-control"
                  v-model="studySemester"
                  style="width: 150px"
                >
                  <option value="1" selected>1</option>
                  <option value="2">2</option>
                </select>
              </div>
              <br />
              <!-- ปุ่มบันทึก -->
              <button
                @click="updateAutoSystem"
                class="btn btn-success"
                :disabled="isSystemOpen"
              >
                เปิดระบบ
              </button>
            </div>
          </div>
        </div>
      </div>

       <header class="text-center">
        <h1>ตั้งค่าระบบสำหรับการแก้ไขคำร้อง</h1>
      </header>
      <div class="container-fluid">
        <div class="py-1 px-5">
          <div class="bg-secondary-light mb-3">
            <!-- สถานะของระบบปัจจุบัน -->
            <div style="background-color: #964040" class="p-3">
              <span>
                <h4 class="text-white my-0">สถานะของระบบสำหรับการแก้ไขคำร้อง</h4>
              </span>
            </div>
            <!-- แสดงสถานะปัจจุบัน -->
            <div class="status-container">
              <div
                :class="{
                  'status-open': isSystemOpen_editLoan,
                  'status-closed': !isSystemOpen_editLoan,
                }"
              >
                <strong>สถานะของระบบ:</strong>
                {{ isSystemOpen_editLoan ? "เปิดใช้งาน" : "ปิดใช้งาน" }}
              </div>
            </div>
            <!-- แสดงวันเวลาที่ตั้ง Auto -->
            <div class="auto-status">
              <p>
                <strong>ระบบ Auto ตั้งค่าไว้:</strong> เปิดวันที่
                {{ formatDate(autoStartDate_editLoan) }} ถึง
                {{ formatDate(autoEndDate_editLoan) }}
                <br />
                ปีการศึกษา {{ studyYear_editLoan }}
              </p>
            </div>

            <!-- ปุ่มเปิด/ปิด Manual -->
            <div style="background-color: #964040" class="p-3">
              <span>
                <h4 class="text-white my-0">การเปิด-ปิดระบบ (manual)</h4>
              </span>
            </div>
            <div class="manual-action-container">
              <button
                class="btn"
                :class="
                  isSystemOpen_editLoan ? 'btn-success' : 'btn-outline-success'
                "
                :disabled="
                  isUpdatingSystemStatusEditLoan || isSystemOpen_editLoan
                "
                @click="updateSystemStatus_editLoan('open')"
              >
                เปิดระบบทันที
              </button>
              <button
                class="btn"
                :class="
                  !isSystemOpen_editLoan ? 'btn-danger' : 'btn-outline-danger'
                "
                :disabled="
                  isUpdatingSystemStatusEditLoan || !isSystemOpen_editLoan
                "
                @click="updateSystemStatus_editLoan('close')"
              >
                ปิดระบบทันที
              </button>
            </div>

            <!-- ตั้งค่า Auto -->
            <div style="background-color: #964040" class="p-3">
              <span>
                <h4 class="text-white my-0">การเปิด-ปิดระบบ (auto)</h4>
              </span>
            </div>
            <div class="form-group ml-3">
              <div class="row mb-3">
                <!-- กล่องเลือกวันเปิดระบบ -->
                <div class="col-auto mb-2">
                  <label for="autoStartDate_editLoan">เลือกวันเปิดระบบ:</label>
                  <input
                    type="date"
                    id="autoStartDate_editLoan"
                    v-model="autoStartDate_editLoan"
                    class="date-input"
                  />
                </div>

                <!-- กล่องเลือกวันปิดระบบ -->
                <div class="col-md-auto">
                  <label for="autoEndDate_editLoan">เลือกวันปิดระบบ:</label>
                  <input
                    type="date"
                    id="autoEndDate_editLoan"
                    v-model="autoEndDate_editLoan"
                    class="date-input"
                  />
                </div>
                <!-- กล่องเลือกปีการศึกษา  -->
              </div>

              <div class="studyYear-box">
                <label for="studyYear_editLoan">เลือกปีการศึกษา:</label>
                <div class="mb-3">
                  <input
                    type="number"
                    id="studyYear_editLoan"
                    v-model="studyYear_editLoan"
                    class="form-control"
                    :min="currentThaiYear - 1"
                    :max="currentThaiYear + 1"
                    @input="validateNumber('studyYear_editLoan')"
                    @keydown="blockNegative"
                  />
                </div>
                <label for="studySemester_editLoan">เลือกภาคเรียนการศึกษา:</label>

                <select
                  name="studySemester_editLoan"
                  id="studySemester_editLoan"
                  class="form-control"
                  v-model="studySemester_editLoan"
                  style="width: 150px"
                >
                  <option value="1" selected>1</option>
                  <option value="2">2</option>
                </select>
              </div>
              <br />
              <!-- ปุ่มบันทึก -->
              <button
                @click="updateAutoSystem_editLoan"
                class="btn btn-success"
                :disabled="isSystemOpen_editLoan"
              >
                เปิดระบบ
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StaffNavbar from "./NavBar_staff.vue";

export default {
  name: "StaffPageSetting",
  components: {
    StaffNavbar,
  },
  data() {
    return {
      isSystemOpen: false,
      systemStatus: "close",
      systemMode: "manual",
      isUpdatingSystemStatus: false,
      autoStartDate: "",
      autoEndDate: "",
      studyYear: new Date().getFullYear() + 543,
      studySemester: null,

      isSystemOpen_editLoan: false,
      systemStatus_editLoan: "close",
      isUpdatingSystemStatusEditLoan: false,
      autoStartDate_editLoan: "",
      autoEndDate_editLoan: "",
      studyYear_editLoan: new Date().getFullYear() + 543,
      studySemester_editLoan: null,
      currentThaiYear: new Date().getFullYear() + 543,
    };
  },
  created() {
    this.fetchSystemStatus();
    this.fetchSystemStatus_editLoan();
  },
  methods: {
    fetchSystemStatus() {
      fetch(
        `${process.env.VUE_APP_API_BASE_URL}/staff/get/system_status?` +
          new Date().getTime(),
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.isSystemOpen = data.status === "open";
          this.systemStatus = data.status;
          this.systemMode = data.mode;
          this.autoStartDate = data.autoOpenDate || "";
          this.autoEndDate = data.autoCloseDate || "";
          this.studyYear = data.study_year;
          this.studySemester = data.study_semester;
        })
        .catch((error) =>
          console.error("Error fetching system status:", error)
        );
    },
    updateSystemStatus(status) {
      this.isUpdatingSystemStatus = true;
      fetch(`${process.env.VUE_APP_API_BASE_URL}/staff/update/system_status`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ status }),
      })
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok) {
            throw new Error(data.error || data.message || "Update failed");
          }
          return data;
        })
        .then((data) => {
          this.systemStatus = status;
          alert(data.message);
          setTimeout(() => {
            this.fetchSystemStatus();
          }, 500);
        })
        .catch((error) => {
          console.error("Error updating system status:", error);
          alert(error.message);
        })
        .finally(() => {
          this.isUpdatingSystemStatus = false;
        });
    },
    updateAutoSystem() {
      if (!this.isValidStudyPeriod(this.studyYear, this.studySemester)) return;

      fetch(`${process.env.VUE_APP_API_BASE_URL}/staff/update/system_auto`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          startDate: this.autoStartDate,
          endDate: this.autoEndDate,
          studyYear: this.studyYear,
          studySemester: this.studySemester,
        }),
      })
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok) throw new Error(data.error || "Update failed");
          return data;
        })
        .then((data) => {
          alert(data.message);
          setTimeout(() => {
            this.fetchSystemStatus();
          }, 500);
        })
        .catch((error) => console.error("Error updating auto system:", error));
    },
    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    fetchSystemStatus_editLoan() {
      fetch(
        `${process.env.VUE_APP_API_BASE_URL}/staff/get/system_status/editLoan?` +
          new Date().getTime(),
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          this.isSystemOpen_editLoan = data.status === "open";
          this.systemStatus_editLoan = data.status;
          this.systemMode_editLoan = data.mode;
          this.autoStartDate_editLoan = data.autoOpenDate || "";
          this.autoEndDate_editLoan = data.autoCloseDate || "";
          this.studyYear_editLoan = data.study_year;
          this.studySemester_editLoan = data.study_semester;
        })
        .catch((error) =>
          console.error("Error fetching system status:", error)
        );
    },
    updateSystemStatus_editLoan(status) {
      this.isUpdatingSystemStatusEditLoan = true;
      fetch(`${process.env.VUE_APP_API_BASE_URL}/staff/update/system_status/editLoan`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ status }),
      })
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok) {
            throw new Error(data.error || data.message || "Update failed");
          }
          return data;
        })
        .then((data) => {
          this.systemStatus_editLoan = status;
          alert(data.message);
          setTimeout(() => {
            this.fetchSystemStatus_editLoan();
          }, 500);
        })
        .catch((error) => {
          console.error("Error updating system status:", error);
          alert(error.message);
        })
        .finally(() => {
          this.isUpdatingSystemStatusEditLoan = false;
        });
    },
    updateAutoSystem_editLoan() {
      if (!this.isValidStudyPeriod(this.studyYear_editLoan, this.studySemester_editLoan)) return;

      fetch(`${process.env.VUE_APP_API_BASE_URL}/staff/update/system_auto/editLoan`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          startDate: this.autoStartDate_editLoan,
          endDate: this.autoEndDate_editLoan,
          studyYear: this.studyYear_editLoan,
          studySemester: this.studySemester_editLoan,
        }),
      })
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok) throw new Error(data.error || "Update failed");
          return data;
        })
        .then((data) => {
          alert(data.message);
          setTimeout(() => {
            this.fetchSystemStatus_editLoan();
          }, 500);
        })
        .catch((error) => console.error("Error updating auto system:", error));
    },

    isValidStudyPeriod(studyYear, studySemester) {
      const allowedYears = [
        this.currentThaiYear - 1,
        this.currentThaiYear,
        this.currentThaiYear + 1,
      ];
      if (!allowedYears.includes(Number(studyYear))) {
        alert(`ปีการศึกษาต้องเป็นปี พ.ศ. ${allowedYears.join(" หรือ ")}`);
        return false;
      }
      if (!["1", "2"].includes(String(studySemester))) {
        alert("ภาคเรียนต้องเป็น 1 หรือ 2");
        return false;
      }
      return true;
    },
    validateNumber(fieldName) {
      // Ensure the value is a positive integer and remove invalid characters
      this[fieldName] = this[fieldName]
        ? this[fieldName].toString().replace(/\D/g, "")
        : "";

      // Prevent leading zeros
      if (this[fieldName].startsWith("0")) {
        this[fieldName] = this[fieldName].replace(/^0+/, "");
      }
    },
    blockNegative(event) {
      // Prevent typing '-' and 'e' (in some browsers)
      if (event.key === "-" || event.key === "e") {
        event.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
.status-open {
  color: green;
  font-weight: bold;
}

.status-closed {
  color: red;
  font-weight: bold;
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0 0 0;
  text-align: center;
}

.bg-secondary-light {
  background-color: rgba(108, 117, 125, 0.2);
}

input {
  outline: none;
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 5px;
  width: 150px;
}

label {
  font-size: 14px;
  margin-bottom: 4px;
}

.form-group {
  margin-bottom: 20px;
  padding: 15px 0 15px 0;
}

.d-flex {
  display: flex;
  align-items: center;
}

.mx-2 {
  margin-left: 10px;
  margin-right: 10px;
}

.mr-3 {
  margin-right: 20px;
}

.ml-3 {
  margin-left: 15px;
}

.mt-3 {
  margin-top: 20px;
}

.custom-button:hover {
  background-color: #218838;
}

.status-container {
  text-align: left;
  margin-left: 20px;
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
}

.radio-container {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.manual-action-container {
  display: flex;
  gap: 12px;
  margin: 16px 20px;
}

.d-flex.align-items-start {
  justify-content: flex-start;
}

.date-input {
  width: 150px;
  text-align: left;
}

.radio-button {
  margin-right: 10px;
  width: 16px;
  height: 16px;
  accent-color: #964040;
}

.auto-status {
  margin-left: 20px;
}
</style>
